import { KeyboardHelper } from '#pplx/frontend/components/utils/keyboardHelpers.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { useCallback, useRef } from 'react';
export function useAskInputKeydown({ value, json, isDisabled, handleSubmit, handleSuggestDropdownNavigation, querySource, onDisabledSubmit, onKeyDown, }) {
    const { isMobileUserAgent } = useIsMobile();
    const valueRef = useRef(value);
    const jsonRef = useRef(json);
    valueRef.current = value;
    jsonRef.current = json;
    const handleDisabledState = useCallback((e) => {
        if (isDisabled && KeyboardHelper.isEnterKeyWithoutShift(e)) {
            // Prevent default Enter key behavior — submit search query programmatically
            e.preventDefault();
            onDisabledSubmit?.();
            return true;
        }
        return false;
    }, [isDisabled, onDisabledSubmit]);
    const handleIMEComposition = useCallback((e) => {
        if (e.isComposing) {
            // Prevent keydown from firing during IME composition — wait for compositionend
            e.preventDefault();
            return true;
        }
        return false;
    }, []);
    const handleRegularSubmission = useCallback((e) => {
        if (KeyboardHelper.isEnterKeyWithoutShift(e) && !isMobileUserAgent) {
            // Prevent default Enter key behavior — submit search query programmatically
            e.preventDefault();
            handleSubmit({
                attempt: { method: 'keyboard', fromQueue: false },
                query: valueRef.current,
                json: jsonRef.current,
                querySource,
            });
        }
    }, [handleSubmit, querySource, isMobileUserAgent]);
    const handleKeyDown = useCallback((e) => {
        if (handleDisabledState(e) || handleIMEComposition(e))
            return;
        if (handleSuggestDropdownNavigation(e))
            return;
        // Parent-owned key handling runs after suggestions so autocomplete keeps
        // priority, but before submission/native editor behavior when it claims a key.
        if (onKeyDown?.(e))
            return;
        handleRegularSubmission(e);
    }, [
        handleDisabledState,
        handleIMEComposition,
        handleSuggestDropdownNavigation,
        onKeyDown,
        handleRegularSubmission,
    ]);
    return handleKeyDown;
}
//# sourceMappingURL=useAskInputKeydown.js.map